import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function RestoreModal({
  open,
  itemName,
  handleCancel,
  handleRestore,
  loading = false,
}) {
  return (
    <Dialog open={open} TransitionComponent={Transition} keepMounted onClose={handleCancel}>
      <DialogTitle className="font-bold uppercase">
        Restore {itemName || "organisation"} ?
      </DialogTitle>
      <hr />
      <DialogContent>
        <DialogContentText className="text-lg py-3">
          Restore <strong>{itemName || "this organisation"}</strong> to the active organisations
          list? It will become visible in the UI and API again.
        </DialogContentText>
      </DialogContent>
      <hr />
      <DialogActions className="py-2">
        <Button onClick={handleCancel} variant="outlined" disabled={loading}>
          Cancel
        </Button>
        <Button onClick={handleRestore} variant="contained" color="primary" disabled={loading}>
          {loading ? "Restoring…" : "Restore"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
